define('modules/form_editor/views/editor_checkradio_item',['require','exports','module','base/itemview','i18n','ldsh!../templates/editor_check_item'],function (require, exports, module) {
  'use strict';
  var ItemView = require('base/itemview'),
      i18n = require('i18n');

  module.exports = ItemView.extend({
    template: require('ldsh!../templates/editor_check_item'),
    className: 'ed-form-group ed-input-group',
    events: {
      'change .js-text': 'updateModel',
      'change .js-value-text': 'updateModel',
      'change .js-selected': 'updateModel',
      'change .js-item-required': 'updateModel',
      'click .js-add': 'addItem',
      'click .js-remove': 'removeItem',
      'click .js-toggle-value': 'toggleValue'
    },

    helpers: function () {
      var text = this.model.get('text'),
          key = ['formEditor', 'social', text].join('.');

      var radioParams = {
        checked: this.model.get('selected') ? 'checked' : '',
        radioText: i18n.exists(key) ? i18n.t(key) : text,
        value: this.model.get('valid') ? this.model.get('value') || text : '',
        isItemRequired: this.model.get('isItemRequired'),
        renderItemRequired: this.parent.model.get('name') !== 'input:radiogroup',
        itemId: this.model.cid,
      };

      return radioParams;
    },

    updateModel: function () {
      var updateModelData = {
        text: this.$('.js-text').val().trim(),
        selected: this.$('.js-selected').is(':checked'),
        value: this.$('.js-value-text').val().trim(),
        isItemRequired: this.$('.js-item-required').is(':checked')
      };

      this.stopListening(this.model);
      this.model.set(updateModelData);
      this.listenTo(this.model, 'change', this.render);
      this.trigger('item:change', this.model);
    },

    addItem: function () {
      this.trigger('item:add', this.model);
    },

    removeItem: function () {
      this.trigger('item:remove', this.model);
    },

    toggleValue: function () {
      this.$('.js-item-value').toggleClass('hidden');
    },

    onRender: function () {
      this.$el.i18n();
    }
  });
});

